module.exports = __webpack_public_path__ + "cam.png?8cf1e70a637f2da7a57560303fac6207";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/empty/cam.png
// module id = 933
// module chunks = 0